import { makeEnvironmentProviders } from '@angular/core';
import { BASE_PATH, Configuration } from '@crd-api/api';
import { environment } from '../../environments/environment';

function resolveServiceBase(): string {
  const serviceBase = environment.SERVICE_BASE;

  if (serviceBase) {
    return serviceBase;
  }

  return window.location.origin;
}

export function provideCrdApi() {
  return makeEnvironmentProviders([
    {
      provide: BASE_PATH,
      useFactory: resolveServiceBase,
    },
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: resolveServiceBase(),
          withCredentials: true,
        }),
    },
  ]);
}
